import script from "./ForgotPasswordFlow.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordFlow.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordFlow.vue?vue&type=style&index=0&id=551e38bb&lang=css"

const __exports__ = script;

export default __exports__